<template>
  <v-container
    fluid
    grid-list-xl
    pa-0
  >
    <template>
      <div>
        <v-layout
          wrap
          align-center
        >
          <v-flex
            xs10
            sm4
          >
            <h2 class="mb-2">Select Domain:</h2>
            <v-autocomplete
              v-model="domains.selected"
              :items="domains.options"
              background-color="rgba(48, 127, 255, 0.1)"
              append-icon="expand_more"
              @change="setDomain"
              label="No selection"
              class="ex-dropdown"
              item-text="domain"
              item-value="id"
              solo
            >
            </v-autocomplete>
          </v-flex>
          <v-flex
            xs10
            sm4
          >
            <h2 class="mb-2">Select Routine:</h2>
            <v-autocomplete
              v-model="domains.routine.selected"
              :items="domains.routine.options"
              background-color="rgba(48, 127, 255, 0.1)"
              append-icon="expand_more"
              @change="setDomain"
              label="No selection"
              class="ex-dropdown"
              item-text="name"
              item-value="id"
              solo
            >
            </v-autocomplete>
          </v-flex>
          <v-flex
            xs10
            sm2
          >
            <v-btn
              class="ex-btn ex-primary-btn text--white"
              v-if="domains.selected && tableData.length == 0"
              @click="addBlockAt(0,0,'pageBlock')"
            >Add page at 0,0</v-btn>
          </v-flex>
        </v-layout>
      </div>
    </template>
    <div>
      <ex-card
        disable-offsets
        v-if="domains.urls.length !== 0"
      >
        <template slot="header">
          <div class="inner">
            <h2>Domains URLs</h2>
          </div>
          <div class="domains-url">
            <div
              class="w-100"
              v-for="(url, key) in domains.urls"
              :key="key"
            >
              <v-text-field
                placeholder="Test Url Here"
                v-model="url.url"
              />
            </div>
          </div>
        </template>
      </ex-card>
      <ex-card
        disable-offsets
        class="result-list-block"
        v-show="testResults.length !== 0"
      >
        <template slot="header">
          <div class="inner">
            <h2>Result List</h2>
          </div>
        </template>
        <template>
          <div class="ex-card-body">
            <div
              v-for="(item, i) in testResults"
              :key="i"
              class="result-list-item"
            >
              <div
                v-for="(val, y) in item"
                :key="y"
              >
                <v-layout>
                  <v-flex
                    xs10
                    sm1
                  >
                    <p>{{ y }}:</p>
                  </v-flex>
                  <v-flex
                    xs10
                    sm11
                  >
                    <p>{{ val !== '' ? val : '-' }}</p>
                  </v-flex>
                </v-layout>
              </div>
            </div>
          </div>
        </template>
      </ex-card>
      <ex-card
        disable-offsets
        class="selector-chain"
        v-if="showSelectorChainBlock"
      >
        <template slot="header">
          <div class="inner">
            <h2>Selector Chain</h2>
            <div>
              <v-btn
                v-show="canTest"
                @click="testTableChain()"
                :loading="test_btn_loading"
              >Test</v-btn>
              <v-btn
                v-show="saveChain"
                @click="saveTableChain()"
                :loading="save_btn_loading"
              >Save</v-btn>
              <v-btn
                @click="loadTableChain()"
                :loading="load_btn_loading"
              >Load</v-btn>
            </div>
          </div>
        </template>
        <template>
          <div class="ex-card-body">
            <v-flex
              xs10
              sm4
              v-show="Object.entries(domains.selected).length !== 0"
            >
              <p class="mb-2">Seller :</p>
              <v-select
                v-model="domains.sellers.selected"
                :items="domains.sellers.options"
                label="No selection"
                class="ex-dropdown medium"
                item-text="value"
                item-value="id"
                solo
              >
              </v-select>
            </v-flex>
            <v-flex>
              <p class="mb-2">Available variables:</p>
              <v-btn
                v-for="(data, i) in variables"
                :key=i
                :title="data.value"
              >{{data.id}}</v-btn>
            </v-flex>
          </div>
        </template>
        <template>
          <div class="ex-selector-table">
            <table>
              <tr
                v-for="(y,idY) in tableData"
                :key="idY"
              >
                <td
                  v-for="(x,idX) in y"
                  :key="idX"
                >
                  <div class="ex-selector-cell">
                    <div
                      ref="actualBlocks"
                      @add="add"
                      @remove="remove"
                      @blockDialog="blockDialog"
                      @addGlobalVars="addGlobalVars"
                      :x=idX
                      :y=idY
                      :is="x"
                      :variables=variables
                      :db_properties=db_properties
                    ></div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </template>
      </ex-card>
      <!--    Dialog -->
      <v-dialog
        v-model="showDialogBlockLink"
        width="500"
        v-if="blockModal.input"
      >
        <v-card>
          <v-card-title
            class="headline"
            dark-title
          >
            Modal Block linking to: {{blockModal.input}}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mb-3">
            <ex-card disable-offsets>
              <template slot="header">
                <v-flex
                  xs10
                  sm4
                >
                  <p class="mb-2">Select Block:</p>
                  <v-select
                    v-model="blockModal.blocks.selected"
                    :items="blockModal.blocks.available"
                    @change="getModalMethods"
                    label="No selection"
                    class="ex-dropdown link"
                    item-text="text"
                    solo
                  >
                  </v-select>
                </v-flex>
                <v-flex
                  xs10
                  sm4
                  v-if="blockModal.blocks.selected !== ''"
                >
                  <p class="mb-2">Select Method:</p>
                  <v-select
                    v-model="blockModal.methods.selected"
                    :items="blockModal.methods.available"
                    @change="getModalOutputs"
                    label="No selection"
                    class="ex-dropdown link"
                    item-text="text"
                    solo
                  >
                  </v-select>
                </v-flex>
                <v-flex
                  xs10
                  sm4
                  v-if="blockModal.methods.selected !== ''"
                >
                  <p class="mb-2">Select Output:</p>
                  <v-select
                    v-model="blockModal.outputs.selected"
                    :items="blockModal.outputs.available"
                    label="No selection"
                    class="ex-dropdown link"
                    item-text="text"
                    solo
                  >
                  </v-select>
                </v-flex>
                <!--                <v-flex xs10 sm3>-->
                <!--                  <p class="mb-2">Selected Type: {{blockModal.blocks.selected}}</p>-->
                <!--                </v-flex>-->
                <!--                <v-btn class="ex-btn ex-primary-btn text&#45;&#45;white" v-if="showSaveBlock" @click="placeBlock(blockModal.pos.y, blockModal.pos.x, blockModal.blocks.selected)">-->
                <!--                  Add {{blockModal.blocks.selected}} at ({{blockModal.pos.y}} , {{blockModal.pos.x}})-->
                <!--                </v-btn>-->
              </template>
            </ex-card>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-layout
              wrap
              align-center
              justify-space-between
            >
              <v-flex
                xs10
                sm6
              >
                <div>Selected Type: {{blockModal.blocks.selected}}</div>
              </v-flex>
              <v-flex
                xs10
                sm4
                class="d-flex justify-end"
              >
                <v-btn
                  class="ex-btn ex-primary-btn text--white"
                  v-if="showSaveBlock"
                  @click="placeBlock(blockModal.pos.y, blockModal.pos.x, blockModal.blocks.selected)"
                >
                  Add {{blockModal.blocks.selected}} at ({{blockModal.pos.y}} , {{blockModal.pos.x}})
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import Add from '../components/selector/Add'
import Empty from '../components/selector/Empty'
import Right from '../components/selector/Right'
import Bottom from '../components/selector/Bottom'
import Corner from '../components/selector/Corner'
import Extract from '../components/selector/Extract'
import Open from '../components/selector/Open'
import SaveAs from '../components/selector/SaveAs'
import Logic from '../components/selector/Logic'
import Expression from '../components/selector/Expression'
import pageBlock from '../components/selector/Page'
import { AppUrl } from '../assets/js/variables'
import JwtService from '@/assets/js/JwtService'
export default {
  name: 'Selector',
  components: {
    Empty, Right, Extract, pageBlock, Open, SaveAs, Bottom, Corner, Add, Expression, Logic
  },
  data: () => ({
    db_properties: [],
    showDialogBlockLink: false,
    showSelectorChainBlock: false,
    test_btn_loading: false,
    save_btn_loading: false,
    load_btn_loading: false,
    blockModal: {
      blocks: { available: [], selected: '' },
      methods: { available: [], selected: '' },
      outputs: { available: [], selected: '' },
      pos: { y: 0, x: 0 },
      data: {},
      input: ''
    },
    domains: {
      options: [],
      selected: {},
      urls: [],
      sellers: {
        options: [],
        selected: {}
      },
      routine: {
        options: [{ id: 1, name: 'main_product_extraction' }, { id: 2, name: 'alias_creation_type_1' }],
        selected: { id: 1, name: 'main_product_extraction' }
      }
    },
    testResults: [],
    consoleUrl: 'https://www.mediamarkt.gr/el/product/_huawei-freebuds-lite-wireless-ceramic-white-1222782.html',
    variablesFromBlocks: [],
    variables: [],
    tableData: [],
    actualBlocks: [],
    selectedBlock: '',
    availableBLocks: ['extract', 'pageBlock', 'open', 'saveAs', 'expression', 'logic'],
    endPoint: [],
    saveChain: true
  }),
  created () {
    this.loadDomains()
  },
  methods: {
    findBlock (y, x) {
      var result = this.$refs.actualBlocks.filter(obj => {
        return (obj.y === y && obj.x === x)
      })
      return result[0]
    },
    findSource (y, x) {
      // Check left
      var result = this.$refs.actualBlocks.filter(obj => {
        return (obj.y === y && obj.x === (x - 1))
      })
      if (this.availableBLocks.includes(result[0].$options._componentTag)) {
        return result[0]
      }
      // Check top
      for (var k = y; k >= 0; k--) {
        result = this.$refs.actualBlocks.filter(obj => {
          return (obj.y === k && obj.x === (x - 1))
        })
        if (result.length > 0) {
          if (this.availableBLocks.includes(result[0].$options._componentTag)) {
            return result[0]
          }
        }
      }
    },
    blockDialog (y, x) {
      var source = this.findBlock(y, x)
      var input = source.$data.output
      this.getModalBlocks(input)
      this.$set(this.blockModal, 'pos', { y: y, x: x })
      this.$set(this.blockModal, 'input', input)
    },
    addGlobalVars (y, x, properties) {
      if (this.variablesFromBlocks[y] === undefined) {
        this.variablesFromBlocks[y] = []
      }
      if (this.variablesFromBlocks[y][x] === undefined) {
        this.variablesFromBlocks[y][x] = []
      }
      this.variablesFromBlocks[y][x] = properties
      this.$set(this, 'variablesFromBlocks', this.variablesFromBlocks)
      this.$set(this, 'variables', this.variablesCalc())
    },
    variablesCalc () {
      var variables = []
      if (this.variablesFromBlocks) {
        this.variablesFromBlocks.forEach(function (row) {
          row.forEach(function (col) {
            col.forEach(function (property) {
              if (property !== '') {
                variables.push(property)
              }
            })
          })
        })
      }
      return variables
    },
    insertModalData (y, x) {
      var block = this.findBlock(y, x)
      this.$set(block.$data, 'input', this.blockModal.input)
      this.$set(block.$data, 'method', this.blockModal.methods.selected)
      this.$set(block.$data, 'output', this.blockModal.outputs.selected)
      this.clearModal()
    },
    clearModal () {
      this.blockModal = {
        blocks: { available: [], selected: '' },
        methods: { available: [], selected: '' },
        outputs: { available: [], selected: '' },
        pos: { y: 0, x: 0 },
        data: {},
        input: ''
      }
    },
    checkRight (name, y, x) {
      switch (name) {
        case 'empty':
          let self = this
          var found = false
          this.tableData[y].forEach(function (value, i) {
            if (i < x) {
              return
            }
            if (self.availableBLocks.includes(value)) {
              found = true
            }
          })
          break
      }
      return (!found)
    },
    checkLeft (name, y, x) {
      switch (name) {
        case 'empty':
          let self = this
          var found = false
          this.tableData[y].forEach(function (value, i) {
            if (i > x) {
              return
            }
            if (self.availableBLocks.includes(value)) {
              found = true
            }
          })
          break
      }
      return (!found)
    },
    placeBlock (y, x, blockName, data = {}) {
      // Input is the source, output is exit node coords
      let outputY = y
      let outputX = x + 1
      let check = this.checkRight('empty', outputY, outputX)

      if (!check) {
        do {
          outputY++
          if (this.checkRight('empty', outputY, outputX)) {
            if (!this.checkLeft('empty', outputY, outputX)) {
              // Inject line
              this.tableData.splice(outputY, 0, [])
              this.prepareTable(outputY, this.tableData[0].length)
            }
          } else {
            // Check if fail cause of left chain
            if (this.availableBLocks.includes(this.tableData[outputY][outputX - 1])) {
              this.tableData.splice(outputY, 0, [])
              this.prepareTable(outputY, this.tableData[0].length)
              break
            }
          }
        } while (!this.checkRight('empty', outputY, outputX))
      }
      this.addBlockAt(outputY, outputX, blockName, data)
      return { y: outputY, x: outputX }
      // this.$nextTick().then(() => {
      // })
    },
    addBlockAt (y, x, blockName, data = {}) {
      this.showSelectorChainBlock = true
      this.prepareTable(y, x)
      // Actual adding
      this.tableData[y].splice(x, 1, blockName)
      // this.$set(this.tableData, y, this.tableData[y])
      this.$nextTick().then(() => {
        if (x !== 0) {
          this.insertModalData(y, x)
        }
        if (Object.entries(data).length !== 0) {
          var block = this.findBlock(y, x)
          Object.assign(block.$data, data)
          if (typeof block.addGlobalVars !== 'undefined') {
            block.addGlobalVars()
          }
        }
      })
      return true
    },
    emptyRow (y) {
      let empty = true
      this.tableData[y].forEach(function (val, idx) {
        if (val !== 'Empty') {
          empty = false
        }
      })
      return empty
    },
    relocateAddBtn (y, x) {
      if (this.emptyRow(y + 1)) {
        this.tableData[y + 1].splice(x, 1, 'Add')
      } else {
        this.tableData.splice(y + 1, 0, [])
        this.prepareTable(this.tableData.length - 1, this.tableData.length - 1)
        this.tableData[y + 1].splice(x, 1, 'Add')
      }
    },
    prepareTable (y, x) {
      for (var i = 0; i <= y + 1; i++) {
        if (this.tableData[i] === undefined) {
          this.tableData[i] = []
        }
        for (var j = 0; j <= x + 1; j++) {
          if (this.tableData[i][j] === undefined) {
            this.tableData[i].splice(j, 0, 'Empty')
          }
        }
        this.$set(this.tableData, i, this.tableData[i])
      }
    },
    clearConsole () {
      this.blockModal = {
        blocks: { available: [], selected: '' },
        methods: { available: [], selected: '' },
        outputs: { available: [], selected: '' },
        pos: { y: 0, x: 0 },
        data: {},
        input: ''
      }
      this.testResults = []
      this.variablesFromBlocks = []
      this.variables = []
      this.tableData = []
    },
    setDomain () {
      this.showSelectorChainBlock = true
      this.clearConsole()
      this.loadDomainUrls()
      this.loadDbProperties()
      this.loadDomainSellers()
    },
    loadDbProperties () {
      const params = {headers: { Authorization: `Bearer ${JwtService.getToken()}` }}
      var self = this
      axios.post(AppUrl, {
        task: 'loadDbProperties'
      }, params).then(function (response) {
        if (response.data.db_properties) {
          self.db_properties = response.data.db_properties
        }
      })
    },
    loadDomainUrls () {
      const params = {headers: { Authorization: `Bearer ${JwtService.getToken()}` }}
      const self = this
      self.domains.urls = []
      axios.post(AppUrl, {
        task: 'loadDomainUrls',
        payload: { domain_id: self.domains.selected }
      }, params).then(function (response) {
        response.data.urls.forEach(function (val, idx) {
          self.domains.urls.push(val)
        })
        if (self.domains.urls.length === 0) {
          self.domains.urls.push({ id: '', url: '' })
        }
        self.$set(self, 'domains', self.domains)
      })
    },
    loadDomainSellers () {
      const params = {headers: { Authorization: `Bearer ${JwtService.getToken()}` }}
      const self = this
      self.domains.sellers.options = []
      axios.post(AppUrl, {
        task: 'loadDomainSellers',
        payload: { domain_id: self.domains.selected }
      }, params).then(function (response) {
        if (response.data.sellers.length) {
          response.data.sellers.forEach(function (val, idx) {
            self.domains.sellers.options.push({ id: val.seller_id, value: val.seller_name })
          })

          if (response.data.sellers.length === 1) {
            self.domains.sellers.selected = self.domains.sellers.options[0].id
          }

          if (response.data.selected_seller) {
            self.domains.sellers.selected = response.data.selected_seller
            self.variables.push({ id: 'main_sellerId', value: response.data.selected_seller })
          }

          self.$set(self, 'domains', self.domains)
        }
      })
    },
    getModalBlocks (input) {
      const params = {headers: { Authorization: `Bearer ${JwtService.getToken()}` }}
      const self = this
      self.blockModal.blocks.selected = ''
      axios.post(AppUrl, {
        task: 'getModalBlocks',
        payload: { input: input }
      }, params).then(function (response) {
        self.blockModal.blocks.available = response.data.blocks
        if (response.data.blocks.length > 0) {
          self.blockModal.blocks.selected = response.data.blocks[0]
          self.getModalMethods()
        }
        self.$set(self, 'blockModal', self.blockModal)
      })
    },
    getModalMethods () {
      const params = {headers: { Authorization: `Bearer ${JwtService.getToken()}` }}
      var block = this.blockModal.blocks.selected
      const self = this
      self.blockModal.methods.selected = ''
      axios.post(AppUrl, {
        task: 'getModalMethods',
        payload: { block: block, input: self.blockModal.input }
      }, params).then(function (response) {
        self.blockModal.methods.available = response.data.methods
        if (response.data.methods.length > 0) {
          self.blockModal.methods.selected = response.data.methods[0]
          self.getModalOutputs()
        }
        self.$set(self, 'blockModal', self.blockModal)
      })
    },
    getModalOutputs () {
      const params = {headers: { Authorization: `Bearer ${JwtService.getToken()}` }}
      var block = this.blockModal.blocks.selected
      var method = this.blockModal.methods.selected
      const self = this
      self.blockModal.outputs.selected = ''
      axios.post(AppUrl, {
        task: 'getModalOutputs',
        payload: { block: block, method: method, input: self.blockModal.input }
      }, params).then(function (response) {
        self.blockModal.outputs.available = response.data.outputs
        if (response.data.outputs.length > 0) {
          self.blockModal.outputs.selected = response.data.outputs[0]
        }
        self.$set(self, 'blockModal', self.blockModal)
      })
    },
    testTableChain () {
      const params = {headers: { Authorization: `Bearer ${JwtService.getToken()}` }}
      this.test_btn_loading = true
      if (this.canTest) {
        const self = this
        var tableChain = []

        self.$refs.actualBlocks.forEach(function (block) {
          var name = block.$options._componentTag
          if (self.availableBLocks.includes(name)) {
            tableChain.push({ y: block.y, x: block.x, data: JSON.stringify(block.$data), type: name })
          }
        })
        axios.post(AppUrl, {
          task: 'testTableChain',
          payload: {
            testUrls: self.domains.urls,
            tableChain: tableChain,
            domain: self.domains.selected
          }
        }, params).then(function (response) {
          if (response.data.variables) {
            self.$set(self, 'testResults', response.data.variables)

            if (response.data.blocks) {
              if (Object.entries(response.data.blocks).length > 0) {
                self.tableData = []
                self.endPoint = []
                self.addOutputs(response.data.blocks[0], undefined)
              }
            }
            console.log(response.data.blocks[0])
          }
        }).finally(() => { self.test_btn_loading = false })
      }
    },
    saveTableChain () {
      const params = {headers: { Authorization: `Bearer ${JwtService.getToken()}` }}
      const self = this
      var tableChain = []

      self.$refs.actualBlocks.forEach(function (block) {
        var name = block.$options._componentTag
        if (self.availableBLocks.includes(name)) {
          tableChain.push({ y: block.y, x: block.x, data: block.$data, type: name })
        }
      })
      this.save_btn_loading = true
      axios.post(AppUrl, {
        task: 'saveChain',
        payload: {
          tableChain: tableChain,
          domain_id: self.domains.selected,
          seller_id: self.domains.sellers.selected,
          routine_id: self.domains.routine.selected
        }
      }, params).then(function (response) {
        console.log(response.data)
      }).finally(() => { this.save_btn_loading = false })
    },
    loadTableChain () {
      const params = {headers: { Authorization: `Bearer ${JwtService.getToken()}` }}
      const self = this
      this.load_btn_loading = true
      axios.post(AppUrl, {
        task: 'loadChain',
        payload: {
          domain_id: self.domains.selected,
          routine_id: self.domains.routine.selected,
          seller_id: self.domains.sellers.selected
        }
      }, params).then(function (response) {
        if (Object.entries(response.data).length > 0) {
          self.tableData = []
          self.endPoint = []
          self.addOutputs(response.data, undefined)
        }
        console.log(response.data)
      }).finally(() => { this.load_btn_loading = false })
    },
    addOutputs (chain, source) {
      if (source === undefined) {
        this.addBlockAt(0, 0, chain.type, chain.data)
        source = { y: 0, x: 0 }
      } else {
        source = this.placeBlock(source.y, source.x, chain.type, chain.data)
      }
      if (chain.chain.length) {
        const self = this
        chain.chain.forEach(function (chain, idx) {
          self.addOutputs(chain, source)
        })
      }
    },
    loadDomains () {
      const params = {headers: { Authorization: `Bearer ${JwtService.getToken()}` }}
      const self = this
      axios.post(AppUrl, {
        task: 'loadDomains'
      }, params).then(function (response) {
        self.domains.options = response.data.domains
      })
    },
    add (y, x) {
      this.showDialogBlockLink = true
      this.blockDialog(y, x)
    },
    remove (y, x) {
      for (var i = x; i < this.tableData[y].length; i++) {
        this.tableData[y][i] = 'Empty'
      }
      this.$set(this.tableData, y, this.tableData[y])
      if (this.isRowEmpty(this.tableData[y])) {
        this.tableData.splice(y, 1)
      }
      this.$set(this, 'tableData', this.tableData)
    },
    isRowEmpty (table) {
      for (var i = 0; i < table.length; i++) {
        if (this.availableBLocks.includes(table[i])) {
          return false
        }
      }
      return true
    }
  },
  computed: {
    showSaveBlock () {
      if (
        this.blockModal.blocks.selected !== '' &&
        this.blockModal.methods.selected !== '' &&
        this.blockModal.outputs.selected !== ''
      ) {
        return true
      }
      return false
    },
    canTest () {
      return ((this.domains.urls.length > 0) && this.domains.selected)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Selector.vue